import { DoorBatteryWarningLevel, DoorType, WeekScheduleDay } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from './door';
import { generateMockLocation } from './location';

export const mockLocationTestGroup1 = generateMockLocation({ id: 'TestGroup1', name: 'Test group 1' });

export const mockLocationTestGroup2 = generateMockLocation({ id: 'TestGroup2', name: 'Test group 2' });

export const mockDoorOfficeModeWeekDays: WeekScheduleDay[] = [
  { __typename: 'WeekScheduleDay', dayName: 'monday', from: '08:00:00', to: '18:00:00' },
  { __typename: 'WeekScheduleDay', dayName: 'tuesday', from: '08:00:00', to: '18:00:00' },
  { __typename: 'WeekScheduleDay', dayName: 'wednesday', from: '08:00:00', to: '18:00:00' },
  { __typename: 'WeekScheduleDay', dayName: 'thursday', from: '08:00:00', to: '18:00:00' },
  { __typename: 'WeekScheduleDay', dayName: 'friday', from: '08:00:00', to: '18:00:00' }
];

export const mockDoorReader1 = generateMockDoor({
  id: 'mockedDoorId1',
  batteryWarningLevel: DoorBatteryWarningLevel.Powered,
  hardwareIdentifier: '65',
  name: 'Reader 1',
  type: DoorType.DomReader,
  locations: [mockLocationTestGroup1],
  officeMode: { __typename: 'WeekSchedule', weekDays: mockDoorOfficeModeWeekDays }
});

export const mockDoorHandle1 = generateMockDoor({
  id: 'mockedDoorId2',
  batteryWarningLevel: DoorBatteryWarningLevel.BatteryEmpty,
  hardwareIdentifier: '7F',
  name: 'Handle 1',
  type: DoorType.DomHandle,
  locations: [mockLocationTestGroup2],
  officeMode: { __typename: 'WeekSchedule', weekDays: mockDoorOfficeModeWeekDays }
});

export const mockDoorCylinder1 = generateMockDoor({
  id: 'mockedDoorId3',
  batteryWarningLevel: DoorBatteryWarningLevel.BatteryCritical,
  hardwareIdentifier: 'A3',
  name: 'Cylinder 1',
  type: DoorType.DomCylinder,
  locations: [mockLocationTestGroup1, mockLocationTestGroup2]
});

export const mockDoorLocker1 = generateMockDoor({
  id: 'mockedDoorId4',
  batteryWarningLevel: DoorBatteryWarningLevel.BatteryLow,
  hardwareIdentifier: 'ZZ',
  name: 'Locker 1',
  type: DoorType.DomLocker,
  locations: [mockLocationTestGroup1]
});

export const mockDoorController1 = generateMockDoor({
  id: 'mockedDoorId5',
  batteryWarningLevel: DoorBatteryWarningLevel.BatteryUnknown,
  hardwareIdentifier: 'ZZZ',
  name: 'Controller 1',
  type: DoorType.DomController,
  locations: [mockLocationTestGroup2]
});

export const mockDoorSwingHandle1 = generateMockDoor({
  id: 'mockedDoorId6',
  batteryWarningLevel: DoorBatteryWarningLevel.BatteryDefault,
  hardwareIdentifier: '66',
  name: 'Swing handle 1',
  type: DoorType.Tanlock,
  locations: []
});

export const mockDoorController2 = generateMockDoor({
  id: 'mockedDoorId7',
  batteryWarningLevel: DoorBatteryWarningLevel.BatteryDefault,
  hardwareIdentifier: '6E',
  name: 'Controller 2',
  type: DoorType.DomController,
  locations: [mockLocationTestGroup1, mockLocationTestGroup2],
  officeMode: { __typename: 'WeekSchedule', weekDays: mockDoorOfficeModeWeekDays }
});

export const mockDoors = [
  mockDoorReader1,
  mockDoorHandle1,
  mockDoorCylinder1,
  mockDoorLocker1,
  mockDoorController1,
  mockDoorSwingHandle1,
  mockDoorController2
];
